/**
 * Publishes one length on the document element, and nothing else.
 *
 * ADR 0018 forbids restyling the page the widget is embedded in. This
 * property carries a length. It does not paint the host's content.
 * `--toast-lift` is the corner launcher's height plus 16px, so a bottom-right
 * toast that chooses to read it clears that launcher (ADR 0032). A host's
 * toast is the host's own; nothing here moves or styles it.
 *
 * The file keeps its name because ADR 0032 cites it. It also published
 * `--fb-open-w`, the width of the drawer form, until that drawer was withdrawn
 * for the centered modal (I22642); nothing reads that property any more.
 * `host-page-isolation.test.ts` allows only `--toast-lift`, and it matches the
 * literal property string, which is why each call names its property rather
 * than sharing one helper.
 */

export function setHostToastLift(value: string): void {
  if (typeof document === 'undefined') return;
  try {
    document.documentElement.style.setProperty('--toast-lift', value);
  } catch {
    // A locked-down document must not throw into the host page.
  }
}

export function clearHostToastLift(): void {
  if (typeof document === 'undefined') return;
  try {
    document.documentElement.style.removeProperty('--toast-lift');
  } catch {
    // Same boundary as setHostToastLift.
  }
}
